import { SearchProvider } from '@faststore/sdk'
import { ITEMS_PER_PAGE } from 'src/constants'
import { applySearchState } from 'src/sdk/search/state'
import type {
  CollectionPageQueryQuery,
  ServerCollectionPageQueryQuery,
  CollectionPageQueryQueryVariables,
} from '@generated/graphql'
import type { PageProps } from 'gatsby'
import type { SearchState } from '@faststore/sdk'
import type { SearchResult } from 'src/components/sections/ProductGalleryV2/types'
import { useEffect } from 'react'
import { dynamicYieldContextPage } from 'src/utils/dynamicYield/dynamicYieldContextPage'
import ProductGallery from 'src/components/sections/ProductGalleryV2/index'
import { MusePlpEntryPoint } from 'src/components/muse/MusePlpEntryPoint'
import type { ContextualFilter } from 'src/components/department/ContextualFilters'

type ServerData = {
  serverData: {
    searchParams: SearchState
    searchResult: SearchResult
    data: any
    contextualFiltersData?: ContextualFilter[] | null
  }
  slug: string
  type?: string
}

type Props = PageProps<
  CollectionPageQueryQuery,
  CollectionPageQueryQueryVariables,
  unknown,
  ServerCollectionPageQueryQuery
> &
  ServerData

export function CollectionPageTemplate(props: Props) {
  const {
    serverData: { searchParams, searchResult, data, contextualFiltersData },
    type,
  } = props

  const slug = data?.newURL?.split('/').filter(Boolean)
  const titleBySlug = slug ? slug[slug?.length - 1] : ''

  useEffect(() => {
    dynamicYieldContextPage({
      page: 'CATEGORY',
      data: slug,
    })
  }, [slug])

  return (
    <SearchProvider
      onChange={applySearchState}
      itemsPerPage={ITEMS_PER_PAGE}
      {...searchParams}
    >
      <ProductGallery
        title={titleBySlug ?? searchParams?.term ?? ''}
        type="collection"
        dataSports={null}
        pageType={type}
        searchResult={searchResult}
        contextualFiltersData={contextualFiltersData}
      />
      <MusePlpEntryPoint />
    </SearchProvider>
  )
}
